import { useEffect, useRef, useContext } from 'react';
import { useMediaQuery } from 'react-responsive';
import { Formik } from 'formik';
import * as yup from 'yup';
import NavButtons from 'src/components/NavButtons/index';
import StepInfoModal from 'src/components/modal/StepInfoModal';
import DesktopTitle from 'src/components/util/DesktopTitle';
import StepperContext from 'src/store/stepper-context';
import FormObserver from 'src/components/FormObserver';
import FormValidationError from 'src/components/FormValidationError';

export default function Step({
  component: Component,
  initialValues = yup.object(),
  modals = [],
  schema = yup.object(),
  isFirstStep = false,
  isLastStep = false,
  onComplete = () => {},
  label = '',
  onError = () => {},
}) {
  const isDesktop = useMediaQuery({ query: '(min-width: 768px)' });

  //This is required because when the user interacts with the `WebStepper` component and clicks on a step button
  //rather than the next button, it needs to validate the current step.
  //The form reference is required to validate the form, and without it, the `WebStepper` component
  //would not be able to perform validation and submit the form.
  const formikRef = useRef();
  const { setFormikRef } = useContext(StepperContext);
  useEffect(() => {
    window.scrollTo(0, 0);
    setFormikRef(formikRef); // pass the formikRef to the StepperContext on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    formikRef.current?.validateForm();
  }, [formikRef.current?.errors, formikRef.current?.validationSchema]);

  return (
    <>
      {modals}
      <StepInfoModal />
      <Formik
        innerRef={formikRef}
        onSubmit={onComplete}
        initialValues={initialValues}
        validationSchema={schema}
        enableReinitialize
      >
        {() => {
          return (
            <>
              {
                // Render FormValidationError to handle validation errors if an onError function is provided.
                onError && <FormValidationError onError={onError} />
              }
              <FormObserver />
              <div style={{ minHeight: '70vh' }}>
                <DesktopTitle title={label} />
                {Component}
              </div>
              <NavButtons
                disableBack={isFirstStep}
                backText={isDesktop ? 'Previous Step' : 'Back'}
                completeText={
                  isLastStep
                    ? isDesktop
                      ? 'Submit My Filing'
                      : 'Submit'
                    : isDesktop
                    ? 'Continue to next step'
                    : 'Next'
                }
              />
            </>
          );
        }}
      </Formik>
    </>
  );
}
